export default function config() {
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'direction', label: 'Direction' },
    { key: 'category_subject', label: 'Category Subject' },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
  }
}
